/** CatalogSnapshot <-> plain JSON. The engine snapshot carries a Set
 *  (upliftExemptSkus) which JSON drops silently; the persisted basisSnapshot
 *  (ExecQuotePricing.basisSnapshot, spec §1) must survive a JSON round-trip
 *  exactly, so the Set crosses as a sorted array. */
import type { CatalogSnapshot } from './engine';

export type PlainSnapshot = Omit<CatalogSnapshot, 'upliftExemptSkus'> & {
  upliftExemptSkus: string[];
};

export function snapshotToPlain(snap: CatalogSnapshot): PlainSnapshot {
  return { ...snap, upliftExemptSkus: [...snap.upliftExemptSkus].sort() };
}

export function snapshotFromPlain(plain: PlainSnapshot): CatalogSnapshot {
  return { ...plain, upliftExemptSkus: new Set(plain.upliftExemptSkus) };
}
